import { render, staticRenderFns } from "./_withdrawal.vue?vue&type=template&id=57042fec&scoped=true&lang=pug&"
import script from "./_withdrawal.vue?vue&type=script&lang=js&"
export * from "./_withdrawal.vue?vue&type=script&lang=js&"
import style0 from "./_withdrawal.vue?vue&type=style&index=0&id=57042fec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57042fec",
  null
  
)

export default component.exports